// @flow

import serviceProviderService from './serviceProviderService';
import serviceProviderActionKeys from './serviceProviderActionKeys';
import type {
  GetAdsServiceProvidersInfoRequest,
  GetCurrentUsersServiceProvidersRequest,
  GetServiceProviderRequest,
  GetServiceProviderUnreadCountsRequest,
  GetServiceProviderMetricsRequest,
  GetServiceProviderAccountOwnerRequest,
  GetLeafSlugsRequest,
} from './serviceProviderService';

const addAngiLeadsProToServiceProviderCache =
  (angiLeadsSpid: string): {| payload: {| angiLeadsSpid: string |}, type: any |} => ({
    type: serviceProviderActionKeys.ADD_ANGI_LEADS_PRO_TO_SERVICE_PROVIDER_CACHE,
    payload: { angiLeadsSpid },
  });

const getCurrentUsersServiceProviders = ({
  offset,
  limit,
  sortBy,
}: GetCurrentUsersServiceProvidersRequest): {|
  payload: {|
    data: {|
      limit: number,
        offset: number,
          sortBy: "alId" | "name" | "overall_gpa" | "overall_reviews",
              |},
  promise: any,
  |},
type: string,
|} => ({
  type: serviceProviderActionKeys.GET_CURRENT_USERS_SERVICE_PROVIDERS,
  payload: {
    data: { offset, limit, sortBy },
    promise: serviceProviderService.getCurrentUsersServiceProviders({ offset, limit, sortBy }),
  },
});

const getServiceProvider = (serviceProviderId: GetServiceProviderRequest): {|
  payload: {|
    data: {| serviceProviderId: GetServiceProviderRequest |},
promise: any,
  |},
type: string,
|} => ({
  type: serviceProviderActionKeys.GET_SERVICE_PROVIDER,
  payload: {
    data: {
      serviceProviderId,
    },
    promise: serviceProviderService.getServiceProvider(serviceProviderId),
  },
});

const getAdsServiceProvider = (serviceProviderId: GetServiceProviderRequest): {|
  payload: {|
    data: {|serviceProviderId: GetServiceProviderRequest|},
    promise: any,
  |},
  type: string,
|} => ({
  type: serviceProviderActionKeys.GET_ADS_SERVICE_PROVIDER,
  payload: {
    data: {
      serviceProviderId,
    },
    promise: serviceProviderService.getServiceProvider(serviceProviderId),
  },
});

const getAdsServiceProviderInfo = (serviceProviderId: GetAdsServiceProvidersInfoRequest): {|
  payload: {|
    data: {|serviceProviderId: GetAdsServiceProvidersInfoRequest|},
    promise: any,
  |},
  type: string,
|} => ({
  type: serviceProviderActionKeys.GET_ADS_SERVICE_PROVIDER_INFO,
  payload: {
    data: {
      serviceProviderId,
    },
    promise: serviceProviderService.getAdsServiceProviderInfo(serviceProviderId),
  },
});

const getLeadServiceProvider = (serviceProviderId: string): {|
  payload: {|
    data: {| serviceProviderId: string |},
    promise: any,
  |},
  type: string,
|} => ({
  type: serviceProviderActionKeys.GET_LEAD_SERVICE_PROVIDER,
  payload: {
    data: {
      serviceProviderId,
    },
    promise: serviceProviderService.getLeadServiceProvider(serviceProviderId),
  },
});

const updateServiceProviderId =
  (serviceProviderId: ?string): {| payload: ?string, type: string |} => ({
    type: serviceProviderActionKeys.UPDATE_SERVICE_PROVIDER_ID,
    payload: serviceProviderId,
  });

const getServiceProviderUnreadCounts =
  (serviceProviderId: GetServiceProviderUnreadCountsRequest): {|
    payload: {|
      data: {| serviceProviderId: GetServiceProviderUnreadCountsRequest |},
promise: Promise < {| body: any |}>,
  |},
type: string,
|} =>
    ({
      type: serviceProviderActionKeys.GET_SERVICE_PROVIDER_UNREAD_COUNTS,
      payload: {
        data: {
          serviceProviderId,
        },
        promise: serviceProviderService.getServiceProviderUnreadCounts(serviceProviderId),
      },
    });

const getServiceProviderMetrics = (serviceProviderId: GetServiceProviderMetricsRequest): {|
  payload: {|
    data: {| serviceProviderId: GetServiceProviderMetricsRequest |},
promise: any,
  |},
type: string,
|} => ({
  type: serviceProviderActionKeys.GET_SERVICE_PROVIDER_METRICS,
  payload: {
    data: {
      serviceProviderId,
    },
    promise: serviceProviderService.getServiceProviderMetrics(serviceProviderId),
  },
});

const getServiceProviderAccountOwner =
  (serviceProviderId: GetServiceProviderAccountOwnerRequest): {|
    payload: {|
      data: {| serviceProviderId: GetServiceProviderAccountOwnerRequest |},
promise: any,
  |},
type: string,
|} => ({
    type: serviceProviderActionKeys.GET_SERVICE_PROVIDER_ACCOUNT_OWNER,
    payload: {
      data: {
        serviceProviderId,
      },
      promise: serviceProviderService.getServiceProviderAccountOwner(serviceProviderId),
    },
  });

const getLeafSlug = (serviceProviderId: GetLeafSlugsRequest): {|
  payload: any,
  type: any
|} => ({
  type: serviceProviderActionKeys.GET_LEAF_SLUG,
  payload: serviceProviderService.getLeafSlug(serviceProviderId),
});

const getSpProductPackage = (serviceProviderId: string): {|
  payload: {|
    data: {| serviceProviderId: string |},
    promise: any,
  |},
  type: string,
|} => ({
  type: serviceProviderActionKeys.GET_SP_PRODUCT_PACKAGE,
  payload: {
    data: {
      serviceProviderId,
    },
    promise: serviceProviderService.getSpProductPackage(serviceProviderId),
  },
});

const getProProductPackage = (serviceProviderId: string): {|
  payload: {|
    data: {| serviceProviderId: string |},
    promise: any,
  |},
  type: string,
|} => ({
  type: serviceProviderActionKeys.GET_PRO_PRODUCT_PACKAGE,
  payload: {
    data: {
      serviceProviderId,
    },
    promise: serviceProviderService.getProProductPackage(serviceProviderId),
  },
});

export default {
  addAngiLeadsProToServiceProviderCache,
  getCurrentUsersServiceProviders,
  getServiceProvider,
  getAdsServiceProvider,
  getAdsServiceProviderInfo,
  getLeadServiceProvider,
  updateServiceProviderId,
  getServiceProviderUnreadCounts,
  getServiceProviderMetrics,
  getServiceProviderAccountOwner,
  getLeafSlug,
  getSpProductPackage,
  getProProductPackage,
};



// WEBPACK FOOTER //
// ./src/app/common/serviceProvider/serviceProviderActions.js